import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PagerComponentDef } from '@df/ui/display/pager.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'reviews-pager',
    templateUrl: './reviews-pager.html',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewsPagerComponent extends PagerComponentDef {}
